import PermissionDenied from "@/components/information/permissionDenied";

export const information = [
    {path: '/permission-denied', name: 'permissionDenied', component: PermissionDenied}
]